import { render } from "./AdminSysIATab.vue?vue&type=template&id=3c3423f6&ts=true"
import script from "./AdminSysIATab.vue?vue&type=script&lang=ts"
export * from "./AdminSysIATab.vue?vue&type=script&lang=ts"

import "./AdminSysIATab.vue?vue&type=style&index=0&id=3c3423f6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__